import type { Link } from '@app/application/client_meetings/types'
import SFetch from '@app/utils/sfetch'

export async function create(title: string, url: string): Promise<Link | null> {
  const route = window.Silverfin.Routes.client_meetings_links_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId
  )

  return await SFetch.json(route, {
    method: 'POST',
    body: { title, url },
  })
}

async function deleteLink(id: number): Promise<void> {
  const route = window.Silverfin.Routes.client_meetings_link_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    id
  )

  await SFetch.raw(route, {
    method: 'DELETE',
  })
}

export { deleteLink as delete }

export async function fetchPageTitle(
  url: string
): Promise<{ title: string } | null> {
  const route =
    window.Silverfin.Routes.fetch_page_title_client_meetings_links_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId
    )

  return await SFetch.json(route, {
    method: 'POST',
    body: { url },
  })
}
